import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import InterviewSetup from '../components/InterviewSetup';
import AnnouncementModal from '../components/AnnouncementModal';
import { startInterview } from '../store/interviewSlice';
import { auth } from '../services/auth';
import type { InterviewConfig } from '../types';
import type { RootState } from '../store';

export default function HomePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isAnnouncementOpen, setIsAnnouncementOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // 从Redux store获取公告数据
  const announcement = useSelector((state: RootState) => state.config.data?.announcement);

  // 监听用户认证状态变化
  useEffect(() => {
    // 初始化认证状态
    const initAuth = async () => {
      const authenticated = await auth.init();
      setIsAuthenticated(authenticated);
    };
    initAuth();

    // 订阅认证状态变化
    const unsubscribe = auth.subscribe((authenticated) => {
      setIsAuthenticated(authenticated);
    });

    return () => unsubscribe();
  }, []);

  // 在成功获取用户信息后显示公告弹窗
  useEffect(() => {
    // 只有在用户已登录状态下才显示公告
    if (isAuthenticated && announcement) {
      // 延迟一点显示，让用户先看到页面内容
      const timer = setTimeout(() => {
        setIsAnnouncementOpen(true);
      }, 800);
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, announcement]);

  const handleStart = (config: InterviewConfig) => {
    // 使用 Redux 存储面试配置
    dispatch(startInterview(config));
    navigate('/loading');
  };

  return (
    <>
      <InterviewSetup onStart={handleStart} />
      <AnnouncementModal
        isOpen={isAnnouncementOpen}
        onClose={() => setIsAnnouncementOpen(false)}
        announcement={announcement || null}
      />
    </>
  );
}
